<template src="@/templates/file/fileView.html"></template>

<script>
import WorkingWithChildrenModel from "@/models/workingWithChildrenModel";
import ServiceDeliveryFormModel from "@/models/serviceDeliveryFormModel";
import PolicyDocumentsModel from "@/models/policyDocumentsModel";

export default {
  name: "fileView",
  props: ["isThis", "fileName", "titleHeader", "ref_num", "pdID", "isEndDate"],
  data() {
    return {
      fileViewPopUp: true,
      workingWithChildrenModel: new WorkingWithChildrenModel(),
      serviceDeliveryFormModel: new ServiceDeliveryFormModel(),
      policyDocumentsModel: new PolicyDocumentsModel(),
      selectedPath: "",
      selectedFileLink: "",
      file_type: "",
    };
  },
  created: function () {
    console.log("pdID");
    console.log(this.pdID);
    this.viewFile();
  },
  methods: {
    viewFile() {
      // this.$vs.loading({
      // 	type : 'material',
      // });

      console.log("ddd");
      console.log(this.isThis);
      console.log(this.fileName);
      console.log(this.titleHeader);
      console.log(this.ref_num);
      console.log(this.pdID);

      if (this.ref_num > 0) {
        this.selectedPath =
          this.serviceDeliveryFormModel.getRoute("viewUploaded") +
          this.ref_num +
          "/all_slip?token=" +
          localStorage.getItem("jwt");
        this.apiCall();
        return;

        // this.serviceDeliveryFormModel.getImage(this.ref_num).then(SDFMResp => {
        //
        // 	let image = SDFMResp.response.data;
        //
        // 	if ( image.error === true ) {
        // 		let message = 'Image Fetch Error. ' + image.error;
        // 		this.fetchError(message);
        // 	}
        //
        // 	this.file_type = 'data:image/' + image.file_extension + ';base64,';
        // 	this.selectedFileLink = this.file_type + image.content;
        //
        // 	console.log(this.selectedFileLink);
        //
        // 	this.$vs.loading.close();
        //
        // }).catch((PCError) => {
        // 	let errorMessage = "Network error. " + PCError;
        // 	this.fetchError(errorMessage);
        // 	console.error(PCError);
        // });
        // return;
      }

      if (this.pdID > 0) {
        this.selectedPath =
          this.policyDocumentsModel.getRoute("view") +
          localStorage.getItem("jwt") +
          "&pdID=" +
          this.pdID;
        this.apiCall();
        return;
      }

      if (this.fileName != "" || this.fileName == undefined) {
        this.selectedPath =
          this.workingWithChildrenModel.getRoute("view") +
          localStorage.getItem("jwt") +
          "&fileName=" +
          this.fileName;
        this.apiCall();
      }
    },
    fetchError(errorMessage) {
      this.$vs.notify({
        title: "Error!",
        text: errorMessage,
        time: 4000,
        color: "danger",
        position: "top-center",
      });
    },
    apiCall() {
      this.selectedFileLink = this.$interpretersApiUrl + this.selectedPath;
    },
    closeFile() {
      Event.$emit("hideFileViewComp", this.isThis);
    },
  },
};
</script>

<style scoped>
.myPrompt >>> .vs-dialog {
  height: auto !important;
}

.myPdfPrompt >>> .vs-dialog {
  height: 69.3% !important;
}

.myPdfPrompt >>> .vs-dialog-text {
  height: -webkit-fill-available !important;
}
</style>
